export function buildAccuracyReportDetailPath(reportId: string): string {
  return `/accuracy/reports/${encodeURIComponent(reportId)}`;
}

export function buildTuningDraftPath(reportId: string): string {
  return `/accuracy/reports/${encodeURIComponent(reportId)}/tuning-draft`;
}
